<template>
  <div class="mod-overlay" @click.self="$emit('close')">
    <div class="mod-modal">
      <!-- Header -->
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="isEdit ? 'bi bi-pencil' : 'bi bi-plus-circle'"></i>
          {{ isEdit ? 'Editar registro' : 'Nuevo registro' }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <!-- Body -->
      <form @submit.prevent="handleSubmit" class="mod-modal-body">
        <!-- Error -->
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          {{ error }}
        </div>

        <div class="mod-form-grid">
          <!-- MaterialClave -->
          <div class="mod-field">
            <label for="MaterialClave">Material <span class="mod-required">*</span></label>
            <input
              type="text"
              id="MaterialClave"
              v-model="form.MaterialClave"
              :disabled="isEdit"
              required
              maxlength="50"
              placeholder="Clave del material"
            >
          </div>

          <!-- AlmacenClave -->
          <div class="mod-field">
            <label for="AlmacenClave">Almacén <span class="mod-required">*</span></label>
            <input
              type="text"
              id="AlmacenClave"
              v-model="form.AlmacenClave"
              :disabled="isEdit"
              required
              maxlength="50"
              placeholder="Clave del almacén"
            >
          </div>

          <!-- EnStock -->
          <div class="mod-field">
            <label for="EnStock">En Stock</label>
            <input
              type="number"
              id="EnStock"
              v-model.number="form.EnStock"
              step="0.01"
              placeholder="0.00"
            >
          </div>

          <!-- Comprometido -->
          <div class="mod-field">
            <label for="Comprometido">Comprometido</label>
            <input
              type="number"
              id="Comprometido"
              v-model.number="form.Comprometido"
              step="0.01"
              placeholder="0.00"
            >
          </div>

          <!-- Pedido -->
          <div class="mod-field">
            <label for="Pedido">Pedido</label>
            <input
              type="number"
              id="Pedido"
              v-model.number="form.Pedido"
              step="0.01"
              placeholder="0.00"
            >
          </div>
        </div>

        <!-- Footer -->
        <div class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">
            Cancelar
          </button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ isEdit ? 'Guardar cambios' : 'Crear registro' }}
            </template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import materialalmacenService from './materialalmacen.service';
import { showToast } from '@/shared/utils/toast';
import authService from '@/services/auth';
import { createMaterialAlmacen } from './materialalmacen.model';

export default {
  name: 'MaterialAlmacenForm',
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false }
  },
  emits: ['saved', 'close'],
  data() {
    return {
      form: createMaterialAlmacen(),
      saving: false,
      error: null
    };
  },
  created() {
    if (this.isEdit && this.item) {
      this.form = { ...this.item };
    } else {
      const empresa = authService.getSelectedEmpresa();
      this.form.EmpresaId = empresa?.EmpresaId || 0;
    }
  },
  methods: {
    async handleSubmit() {
      this.saving = true;
      this.error = null;

      if (!this.form.MaterialClave || !this.form.AlmacenClave) {
        this.error = 'Material y Almacén son obligatorios';
        this.saving = false;
        return;
      }

      try {
        const result = await materialalmacenService.guardar(this.form);
        if (result.Number >= 0) {
          showToast(result.Message || 'Guardado correctamente', result.Type || 'success');
          this.$emit('saved');
        } else {
          this.error = result.Message || 'Error al guardar';
        }
      } catch (e) {
        console.error('Error al guardar:', e);
        this.error = 'Error de conexion con el servidor';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";
</style>
